/**
 * Return the key and value by name cookie
 * @author Sebastian García <sebastian.garcia@gradiweb.com>
 * @team Support
 */

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export {
  getCookie
}